import { render } from "./SideBarButton.vue?vue&type=template&id=d8e659d6&ts=true"
import script from "./SideBarButton.vue?vue&type=script&lang=ts"
export * from "./SideBarButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__